import { createSelector } from 'redux-orm';
import { orm } from 'model';
import { STATUS_OUTCOME_IDLE } from 'model/palIfpCredential';

const RECORD_ID = 'current';

export const selector = createSelector(orm, ({ PalIfpCredential }) => {
  const record = PalIfpCredential.withId(RECORD_ID);
  return record ? record.ref : null;
});

export const selectorLastReset = createSelector(orm, ({ PalIfpCredential }) => {
  const record = PalIfpCredential.withId(RECORD_ID);
  return record?.ref?.lastReset ?? null;
});

/**
 * Explicit status load outcome: idle | found | notFound.
 * Distinguishes pre-load null credential from soft-miss 404.
 */
export const selectorStatusOutcome = createSelector(
  orm,
  ({ PalIfpCredential }) => {
    const record = PalIfpCredential.withId(RECORD_ID);
    return record?.ref?.statusOutcome ?? STATUS_OUTCOME_IDLE;
  }
);
